// extracted by mini-css-extract-plugin
export var deliveryRow = "_sf-a";
export var fixedHeight = "_sf-4";
export var freightLogo = "_sf-9";
export var fullWidth = "_sf-3";
export var priceColumn = "_sf-5";
export var radioSelected = "_sf-7";
export var radioUnselected = "_sf-6";
export var selectedOption = "_sf-2";
export var selectedOptionContainer = "_sf-1";
export var selection = "_sf-0";
export var tallSkeletonText = "_sf-8";